"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _get = /*#__PURE__*/ _interopRequireDefault(require("lodash/get"));
const _dayjs = /*#__PURE__*/ _interopRequireDefault(require("dayjs"));
const _ = require("..");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const rgx = {
    update_member: new RegExp('PATCH:.+/native_app/v2/members', 'i'),
    create_member: new RegExp('POST:.+/native_app/v1/members', 'i'),
    redeemptions: new RegExp('POST:.+/wallet/v1/members/[a-z0-9]+/redemptions', 'i')
};
const handleRewardRedemptions = (payload)=>{
    const { demoResponses  } = _.api.demoFetch;
    const currentMember = (0, _get.default)(demoResponses, 'wallet.get_member');
    const [item] = currentMember.member.reward_grants.filter((el)=>el.id === payload.reward_grant_id);
    const triggerValueRewardRedemptions = {
        id: payload.reward_grant_id || Math.random(),
        display_image: item.reward.images[0].url,
        reward_name: item.reward.name,
        item_value: `${item.reward.item_value}`,
        transaction_date: (0, _dayjs.default)().toISOString()
    };
    const triggerValueReward = {
        id: 38656,
        created_at: (0, _dayjs.default)().toISOString(),
        redemption_source: 'wallet',
        reward: item.reward || {}
    };
    const currentRewardRedemptions = demoResponses.native_app.reward_redemptions;
    _.api.demoFetch.setInDemoResponses('wallet.redemptions', triggerValueReward);
    currentRewardRedemptions.push(triggerValueRewardRedemptions);
};
const handleRewards = (payload)=>{
    const { demoResponses  } = _.api.demoFetch;
    const currentMember = (0, _get.default)(demoResponses, 'wallet.get_member');
    const [item] = currentMember.member.rewards.filter((el)=>el.id === payload.reward_id);
    const triggerValueReward = {
        id: 38656,
        created_at: (0, _dayjs.default)().toISOString(),
        redemption_source: 'wallet',
        reward: item || {}
    };
    const triggerValueRewardRedemptions = {
        id: payload.reward_grant_id || Math.random(),
        display_image: item.images.length > 0 ? item.images[0].url : '',
        reward_name: item.name,
        item_value: `${item.item_value}`,
        transaction_date: (0, _dayjs.default)().toISOString()
    };
    const currentReward = demoResponses.native_app.reward_redemptions;
    _.api.demoFetch.setInDemoResponses('wallet.redemptions', triggerValueReward);
    _.api.demoFetch.setInDemoResponses('wallet.get_member', {
        errors: {},
        member: {
            ...currentMember.member,
            balance: currentMember.member.balance - item.item_value
        }
    });
    currentReward.push(triggerValueRewardRedemptions);
};
const handleJoinMember = (payload)=>{
    const { demoResponses  } = _.api.demoFetch;
    const currentMember = (0, _get.default)(demoResponses, 'wallet.get_member');
    const merchantLocation = (0, _get.default)(demoResponses, 'native_app.all_locations');
    const composeMember = {
        first_name: payload.first_name,
        last_name: payload.last_name,
        email: payload.email || null,
        city: payload.city || null,
        zip: payload.zip || null,
        address1: payload.address1 || null,
        address2: payload.address2 || null,
        region: payload.region || null
    };
    const memberUpdated = {
        member: Object.assign({}, currentMember.member, composeMember)
    };
    _.api.demoFetch.setInDemoResponses('native_app.all_locations', merchantLocation);
    _.api.demoFetch.setInDemoResponses('native_app.create_member', {
        errors: {},
        member: currentMember.member
    });
    _.api.demoFetch.setInDemoResponses('wallet.get_member', {
        errors: {},
        member: memberUpdated.member
    });
};
const handleUpdateMember = ({ member  })=>{
    const { demoResponses  } = _.api.demoFetch;
    const currentMember = (0, _get.default)(demoResponses, 'wallet.get_member');
    const memberUpdated = {
        member: Object.assign({}, currentMember.member, member)
    };
    _.api.demoFetch.setInDemoResponses('wallet.get_member', {
        errors: {},
        member: memberUpdated.member
    });
    _.api.demoFetch.setInDemoResponses('native_app.update_member', {
        errors: {},
        member: memberUpdated.member
    });
};
_.observer.on('demo-will-fetch', (data)=>{
    const { url , opts  } = data;
    const payload = JSON.parse(opts.body || '{}');
    if (rgx.redeemptions.test(url)) {
        if (payload.reward_grant_id) {
            handleRewardRedemptions(payload);
        }
        if (payload.reward_id) {
            handleRewards(payload);
        }
    }
    if (rgx.create_member.test(url)) {
        handleJoinMember(payload);
    }
    if (rgx.update_member.test(url)) {
        handleUpdateMember(payload);
    }
});
